/**
 * Set equality, order-insensitive: the API takes the full set, so the same locations in a different
 * order is not a change and must leave Update disabled.
 */
export const hasSameLocations = (a: string[], b: string[]): boolean => {
    if (a.length !== b.length) {
        return false;
    }

    const inB = new Set(b);

    return a.every((id) => inB.has(id));
};
